export const secondaryFiletrnslts = {
  en: { animation_note: "This file is only needed if object has animation" },
  cz: {
    animation_note:
      "Tento soubor je potřeba pouze v případě, že objekt má animaci",
  },
  sk: {
    animation_note:
      "Tento súbor je potrebný iba v prípade, že objekt má animáciu",
  },
  de: {
    animation_note:
      "Diese Datei wird nur benötigt, wenn das Objekt eine Animation hat",
  },
  hu: {
    animation_note:
      "Ez a fájl csak akkor szükséges, ha az objektumnak van animációja",
  },
  pl: {
    animation_note:
      "Ten plik jest potrzebny tylko wtedy, gdy obiekt ma animację",
  },
  fr: {
    animation_note:
      "Ce fichier n'est nécessaire que si l'objet a une animation",
  },
  ru: {
    animation_note:
      "Этот файл нужен только в случае, если объект имеет анимацию",
  },
  es: {
    animation_note:
      "Este archivo solo es necesario si el objeto tiene animación",
  },
  nl: {
    animation_note: "Dit bestand is alleen nodig als het object animatie heeft",
  },
  sv: {
    animation_note: "Denna fil behövs endast om objektet har en animation",
  },
  no: {
    animation_note: "Denne filen er bare nødvendig hvis objektet har animasjon",
  },
  da: {
    animation_note:
      "Denne fil er kun nødvendig, hvis objektet har en animation",
  },
  fi: {
    animation_note: "Tämä tiedosto tarvitaan vain, jos objektilla on animaatio",
  },
  ar: {
    animation_note: "هذا الملف مطلوب فقط إذا كان الكائن يحتوي على حركة",
  },
};

export default secondaryFiletrnslts;
